import React, { ReactElement } from 'react';
import { Skeleton, Stack, useTheme } from '@mui/material';

export const ActivityLoadingSkeleton = (): ReactElement => {
  const { palette } = useTheme();

  const ActivityGroupSkeleton = (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1.5,
      }}
    >
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Skeleton
          variant="rectangular"
          width={24}
          height={24}
          sx={{ borderRadius: 1 }}
          animation="wave"
        />
        <Stack>
          <Skeleton
            variant="text"
            sx={{
              fontSize: '1rem',
              borderRadius: 1,
              width: {
                sm: 100,
                md: 320,
              },
            }}
            animation="wave"
          />
          <Skeleton
            variant="text"
            sx={{ fontSize: '1rem', borderRadius: 1 }}
            width={224}
            animation="wave"
          />
        </Stack>
      </Stack>
      <Skeleton
        variant="text"
        sx={{ fontSize: '1rem', borderRadius: 1 }}
        width={80}
        animation="wave"
      />
    </Stack>
  );

  return (
    <Stack
      sx={{
        bgcolor: palette.common.white,
        px: 3,
        minWidth: {
          lg: 600,
        },
      }}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: 'flex-start',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Skeleton
          variant="text"
          sx={{ fontSize: '1rem', borderRadius: 1 }}
          width={80}
          animation="wave"
        />
      </Stack>
      <Stack
        sx={{
          '& > :not(:first-of-type)': {
            marginTop: 2,
          },
          mb: 2,
        }}
      >
        {ActivityGroupSkeleton}
        {ActivityGroupSkeleton}
        {ActivityGroupSkeleton}
        {ActivityGroupSkeleton}
        {ActivityGroupSkeleton}
        {ActivityGroupSkeleton}
        {ActivityGroupSkeleton}
        {ActivityGroupSkeleton}
      </Stack>
    </Stack>
  );
};
